/**
 * Created by Bart Decorte
 * Date: 11/09/2021
 * Time: 16:48
 */
import UploadPreviewListItemImage from './UploadPreviewListItemImage';
import UploadPreviewListItemFile from './UploadPreviewListItemFile';

const EventEmitter = require('events');

export default class UploadPreviewList extends EventEmitter {
  constructor(rootEl, params) {
    super();
    this.rootEl = rootEl;
    this.type = params.type || 'file';
    this.offset = params.offset || 0;
    this.files = [];
    this.previews = []; // List of uploadPreviewListItem instances
    this.indexOffset = 0;
    this.initPreExistingPreviews();
  }

  setProgress(index, progress) {
    this.previews[index].setProgress(progress);
    if (progress >= 1) {
      this.previews[index].setState('success');
    }
  }

  push(files) {
    this.files = [...this.files, ...files];
    this.initPreviews(files);
  }

  clear() {
    this.files = [];
    this.previews = [];
    this.render();
  }

  initPreExistingPreviews() {
    for (let i = 0; i < this.offset; i++) {
      const uploadPreviewListItem = this.initPreExistingPreview(this.indexOffset++);
      this.previews.push(uploadPreviewListItem)
      this.bindPreviewListeners(uploadPreviewListItem);
    }
  }

  initPreviews(files) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const uploadPreviewListItem = this.initPreview(file, this.indexOffset++);
      uploadPreviewListItem.render();
      this.previews.push(uploadPreviewListItem);
      this.render();
      this.bindPreviewListeners(uploadPreviewListItem);
    }
  }

  bindPreviewListeners(uploadPreviewListItem) {
    uploadPreviewListItem.on('canceled', (data) => this.lPreviewCancelled(data));
  }

  // Disregards canceled previews
  continuousIndexOf(uploadPreviewListItem) {
    const items = this.previews.filter(listItem => ! listItem.canceled);
    return items.indexOf(uploadPreviewListItem);
  }

  indexOf(uploadPreviewListItem) {
    return this.previews.indexOf(uploadPreviewListItem);
  }

  lPreviewCancelled({ preview }) {
    this.render();
    this.emitCancellation(preview);
  }

  initPreExistingPreview(index) {
    const el = this.rootEl.querySelector(`.js-upload:not(.js-upload--proto)[data-index="${index}"]`);
    const className = this.typedPreview();
    return new className(el, { index });
  }

  initPreview(file, index = 0) {
    const className = this.typedPreview();
    return new className(this.templateEl(), { index, file });
  }

  render() {
    this.setColumnsVisible();
    this.setRootElVisible();
    const columnEls = this.columnEls();

    columnEls.forEach((columnEl) => {
      [...columnEl.querySelectorAll('.js-upload:not(.js-upload--proto)')].forEach((uploadEl) => {
        uploadEl.remove();
      });
    });

    let renderCount = 0;
    this.previews.forEach((uploadPreviewListItem) => {
      if (!uploadPreviewListItem.canceled) {
        columnEls[renderCount % columnEls.length].appendChild(uploadPreviewListItem.rootEl);
        renderCount++;
      }
    });
  }

  length() {
    return this.previews.filter(preview => !preview.canceled).length;
  }

  typedPreview() {
    const previewTypes = this.previewTypes();
    return previewTypes[this.type];
  }

  previewTypes() {
    return {
      'image': UploadPreviewListItemImage,
      'file': UploadPreviewListItemFile,
    }
  }

  templateEl() {
    const el = this.protoEl().cloneNode(true);
    el.classList.remove('js-upload--proto', 'd-none');

    return el;
  }

  protoEl() {
    return this.rootEl.querySelector('.js-upload--proto');
  }

  columnEls() {
    return this.rootEl.querySelectorAll('.js-uploads__column');
  }

  setColumnsVisible() {
    const hideClass = 'd-none';
    for (let i = 0; i < this.columnEls().length; i++) {
      const columnEl = this.columnEls()[i];
      if (this.length() > i && columnEl.classList.contains(hideClass)) {
        columnEl.classList.remove(hideClass);
      } else if (this.length() <= i && !columnEl.classList.contains(hideClass)) {
        columnEl.classList.add(hideClass);
      }
    }
  }

  setRootElVisible() {
    const hideClass = 'd-none';
    if (this.length() >= 1 && this.rootEl.classList.contains(hideClass)) {
      this.rootEl.classList.remove(hideClass);
    } else if (this.length() < 1 && !this.rootEl.classList.contains(hideClass)) {
      this.rootEl.classList.add(hideClass);
    }
  }

  emitCancellation(preview) {
    this.emit('canceled', { preview });
  }

  cancelPreviewAtIndex(index) {
    const preview = this.previews[index];
    preview.cancel();
    this.emitCancellation(preview);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreviewList.js